export const API_BASE_URL = "https://apidev.tulluapp.com";

export const ENDPOINTS = {
  AUTH: {
    SEND_OTP: "/v1/partner/send-otp",
    VERIFY_OTP: "/v1/partner/verify-otp",
    REFRESH: "/auth/refresh",
    LOGOUT: "/auth/logout",
  },

  CMS: {
    LANDING: "/v1/partner/cms/landing",
  },

  STORAGE: {
    UPLOAD: "/storage/upload-base64",
    UPLOADS: "/storage/upload",
  },

  ONBOARDING: {
    OPTIONS: "/v1/partner/onboarding/options",
    SUBMIT: "/v1/partner/onboarding",
    BUSINESS_PROFILE: "/v1/partner/business-profile",
    REPRESENTATIVE_INSURANCE:
      "/v1/partner/representative-and-insurance",
    SERVICE_AREA:
      "/v1/partner/service-area-locations",
  },

  BILLING: {
    CHECKOUT:
      "/v1/partner/billing/checkout-session",

    SUBSCRIPTION:
      "/v1/partner/billing/subscription-summary",

    SUBSCRIPTION_DETAILS:
      "/v1/partner/billing/subscription-details",

    CHECKOUT_RESULT: (id: string) =>
      `/v1/partner/billing/checkout-result?sessionId=${id}`,

    INVOICES: "/v1/partner/billing/invoices",

    CANCEL_SUBSCRIPTION: "/v1/partner/billing/cancel-subscription",
  },

  CALENDAR: {
    AVAILABILITY: "/v1/partner/calendar-availability",
  },

  DASHBOARD: {
    READINESS: "/v1/partner/dashboard/readiness",
    PROVIDERS: "/v1/partner/providers",
    PARTNER_BOOKINGS: "/v1/partner/bookings",

    SNAPSHOT:
      "/v1/partner/dashboard/snapshot",

    QUICK_ACTIONS:
      "/v1/partner/dashboard/quick-actions",

    ACTION_CENTER:
      "/v1/partner/dashboard/action-center",

    INCOMPLETE_SETUP:
      "/v1/partner/dashboard/incomplete-setup",

    EARNINGS_SUMMARY:
      "/v1/partner/earnings/summary",

    EARNINGS_OVERVIEW:
      "/v1/partner/earnings/overview",

    EARNINGS_TRANSACTIONS:
      "/v1/partner/earnings/transactions",
  },

  CLINICAL: {
    READINESS: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/clinical/readiness`,

    CONSENT_REVIEW: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/clinical/consent-review`,

    CONSENT_ACKNOWLEDGMENT: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/clinical/consent-acknowledgment`,

    VITALS: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/clinical/vitals`,

    IV_MATERIALS: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/clinical/iv-materials`,

    ASSIGNABLE_PROVIDERS: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/assignable-providers`,

    ASSIGN_PROVIDER: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/assign-provider`,

    CANCEL_BOOKING: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/cancel`,

    CUSTOMER_NO_SHOW: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/customer-no-show`,

    STATUS_TIMELINE: (bookingId: string) =>
      `/v1/partner/bookings/${bookingId}/status-timeline`,

    TRACKING_STATUS: (bookingId: string) =>
      `/bookings/${bookingId}/tracking-status`,
  },

  PROVIDERS: {
    LIST: "/v1/partner/providers",
    INVITE: "/v1/partner/providers/invite",
    DETAILS: (id: string) => `/v1/partner/providers/${id}`,
    RESEND_INVITE: (id: string) => `/v1/partner/providers/${id}/resend-invite`,
    REMOVE: (id: string) => `/v1/partner/providers/${id}`,
    VERIFICATION: (id: string) => `/v1/partner/providers/${id}/verification`,
    CATEGORIES: (id: string) => `/v1/partner/providers/${id}/categories`,
    UPDATE: (id: string) => `/v1/partner/providers/${id}`,
    LICENSE_CATEGORIES: "/v1/partner/providers/license-categories",
    TOOLTIPS: "/v1/partner/categories/tooltips",

    VERIFICATION_TRACKER: "/v1/partner/providers/verification-tracker",

    BOOKING_HISTORY: (id: string) =>
      `/v1/partner/providers/${id}/booking-history`,
  },
  STAFF: {
    ADD: "/v1/partner/staff",
  },
  TREATMENTS: {
    LIST: "/v1/partner/treatments",

    DETAILS: (id: string) =>
      `/v1/partner/treatments/${id}`,

    CREATE: "/v1/partner/treatments",

    UPDATE: (id: string) =>
      `/v1/partner/treatments/${id}`,

    DELETE: (id: string) =>
      `/v1/partner/treatments/${id}`,
  },

  STRIPE: {
    ACCOUNT:
      "/v1/partner/stripe/account",

    ONBOARDING_LINK:
      "/v1/partner/stripe/onboarding-link",

    MANAGE_LINK:
      "/v1/partner/stripe/manage-link",

    ACCOUNT_STATUS: (
      refresh?: boolean
    ) =>
      `/v1/partner/stripe/account-status${refresh !== undefined
        ? `?refresh=${refresh}`
        : ""
      }`,
  },

  INDIVIDUAL: {
    PROFILE: "/v1/partner/individual/profile",

    PERSONAL_INFORMATION:
      "/v1/partner/individual/personal-information",

    PROFILE_PHOTO:
      "/v1/partner/individual/profile-photo",

    GOVERNMENT_ID: (side: "front" | "back") =>
      `/v1/partner/individual/government-id/${side}`,

    LICENSE_DOCUMENT:
      "/v1/partner/individual/license-document",

    //////

    individualLicense:
      "/v1/partner/individual/license",

    individualCategories:
      "/v1/partner/individual/categories",

    individualInsurance:
      "/v1/partner/individual/general-liability-insurance",

    individualClinicalOversight:
      "/v1/partner/individual/clinical-oversight",

    uploadLicenseDocument:
      "/v1/partner/individual/license-document",

    uploadInsuranceCertificate:
      "/v1/partner/individual/general-liability-insurance-certificate",

    uploadClinicalProtocol:
      "/v1/partner/individual/clinical-oversight-protocol",

    malpracticeInsurance:
      "/v1/partner/individual/malpractice-insurance",

    uploadMalpracticeInsuranceCertificate:
      "/v1/partner/individual/malpractice-insurance-certificate",

  },

};